import { type ReactElement, type ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { isReminderWizardFullscreenPath } from '@/hooks/use-reminder-wizard-routes';
import { useCreateReminderWizard } from '@/stores/create-reminder-wizard';

import { AppHeader } from './AppHeader';
import { BottomNav } from './BottomNav';

export function AppShell({ children }: { children: ReactNode }): ReactElement {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isFullscreen = isReminderWizardFullscreenPath(location.pathname);
  const endCreateSession = useCreateReminderWizard((s) => s.endCreateSession);

  useEffect(() => {
    if (!isReminderWizardFullscreenPath(location.pathname)) {
      endCreateSession();
    }
  }, [location.pathname, endCreateSession]);

  return (
    <div className="studio-shell relative isolate flex h-[var(--app-height)] flex-col overflow-clip">
      <main
        className="app-scroll mx-auto w-full max-w-3xl min-w-0 flex-1 overflow-x-hidden overflow-y-auto"
        style={{
          paddingBottom: 'calc(var(--bottom-nav-height) + var(--safe-area-inset-bottom) + 0.75rem)',
          paddingLeft: 'max(1rem, var(--safe-area-inset-left))',
          paddingRight: 'max(1rem, var(--safe-area-inset-right))',
        }}
      >
        {!isFullscreen ? (
          <AppHeader
            menuOpen={menuOpen}
            onMenuOpen={() => {
              setMenuOpen(true);
            }}
            onMenuClose={() => {
              setMenuOpen(false);
            }}
          />
        ) : null}
        <div
          className="animate-fade-up px-0"
          style={
            isFullscreen ? { paddingTop: 'calc(var(--safe-area-inset-top) + 0.75rem)' } : undefined
          }
        >
          {children}
        </div>
      </main>
      <BottomNav />
    </div>
  );
}
